// extracted by mini-css-extract-plugin
module.exports = {"headerFlex":"dataset-detail_headerFlex__VCfkv","tableTreeWapper":"dataset-detail_tableTreeWapper__3tFd_"};